import { transformGamesWithJoinedOdds } from '../../services/UserGroup.js';
import { APP_CONFIG, getHeaders } from '../constants/global-variables.js';

export async function getTopTenLiveGames() {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/toptenlivegames`;
    try {
        const res = await axios.get(url, getHeaders());
        return transformGamesWithJoinedOdds(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
